import { render, staticRenderFns } from "./UserCheck.vue?vue&type=template&id=07284e9e&lang=pug"
import script from "./UserCheck.vue?vue&type=script&lang=js"
export * from "./UserCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports